import styles from "./CadastroTechSP.module.scss";
import { /*Alert,*/ Autocomplete, Box, Button, Checkbox, Chip, CircularProgress, Container, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, Link, MenuItem, Radio, RadioGroup, Select, Switch, TextField, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import EmailIcon from '@mui/icons-material/Email';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import logo from '../../../assets/logo-techSP.png'
// import regua from '../../../assets/janelas/regua_de_logos.png'
import InputMask from "react-input-mask";
import { useEffect, useRef, useState } from "react";
import { validaCpf, validaData } from "../../../components/validacoes";
import { Toast } from "../../../services/Swal";
import HelmetThemeColor from "../../../components/HelmetThemeColor/HelmetThemeColor";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import Widget, { setWidgetIsOpen } from "../../../components/Widget/Widget";
import { InputArea } from "../../../components/Box/Box";
import { Input } from "../../../components/Input/Input";
import { ContainedBtn } from "../../../components/ButtonTypes/Button";
import povos from "../../../assets/povosIndigenas.json";
const themeColor = "#4E0094";

const lightTheme = createTheme({
  palette: {
    background: {
      default: "#ffffff",
    },
    primary: {
      main: themeColor,
    },
    secondary: {
      main: "#04ABA3"
    }
  },
});

const box = {
  paddingY: 1,
  display: "flex",
  flexDirection: "column",
  // // alignItems: "center",
  // // border: "1px solid black"
};

function ChipDivider({ label, color = "primary" }) {
  return (
    <Grid item xs={12}>
      <Divider><Chip label={label} color={color} /></Divider>
    </Grid>
  )
}

export default function CadastroTechSP() {
  const [form, setForm] = useState({
    perfil: "",
    dadosPessoais: {
      telecentro: "",
      nomeCompleto: "",
      nomeSocialCompleto: "",
      usoNomeSocial: false,
      nacionalidade: "",
      cpf: "",
      documentoDeIdentifcacao: "",
      nacionalidadeOutro: "",
      dataNascimento: "",
      email: "",
      telefone: "",
      whatsapp: false,
      senha: "",
      confirmacaoSenha: "",
      endereco: {
        cep: "",
        estado: "",
        cidade: "",
        bairro: "",
        rua: "",
        numero: "",
        complemento: ""
      }
    },
    dadosSociodemograficos: {
      genero: "",
      generoOutro: "",
      lgbt: "",
      deficiencia: "",
      refugiado: "",
      raca: "",
      racaOutro: "",
      comunidadeResidencia: "",
      povo: '',
      comprovacaoIndigena: '',
      rani: '',
      escolaridade: '',
      // acessoInternet: '',
      // computador: '',
      ficouSabendo: '',
    },
    termos: []
  });

  const [loading, setLoading] = useState(false);
  const [termos, setTermos] = useState([{}]);

  const [estados, setEstados] = useState();
  const [cidades, setCidades] = useState();
  const [telecentros, setTelecentros] = useState([]);

  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);

  const sectionRef = useRef();
  const [semNumero, setSemNumero] = useState(false)

  useEffect(() => {
    fetch(process.env.REACT_APP_API_ESTADO)
      .then((response) => response.json())
      .then((data) => setEstados(data));
  }, [])

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/api/SMIT/GetListaTelecentros`)
      .then((response) => response.json())
      .then((data) => setTelecentros(data.payload));
  }, [])

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_ESTADO}/${form.dadosPessoais.endereco.estado}/municipios`)
      .then((response) => response.json())
      .then((data) => setCidades(data));
  }, [form.dadosPessoais.endereco.estado])

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/GetTermos/Cadastro?projeto=SMIT`)
      .then((response) => response.json())
      .then((data) => setTermos(data.payload));
  }, [])

  const termosParaEnviar = (termos) => {
    const termosEnviar = [];
    Object.keys(termos).map((termo) => {
      return termosEnviar.push({
        nome: termo,
        aceite: termos[termo],
      });
    });
    return termosEnviar;
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const checkCep = async (e) => {
    const cep = e.target.value;
    if (!cep) return;
    await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((cep) => {
        if (cep.erro) {
          Toast.fire({
            icon: "info",
            title: "CEP não localizado",
          });
        } else {
          setForm({
            ...form,
            dadosPessoais: {
              ...form.dadosPessoais, endereco: {
                ...form.dadosPessoais.endereco,
                estado: cep.uf,
                cidade: cep.localidade,
                rua: cep.logradouro,
                bairro: cep.bairro,
                complemento: cep.complemento,
              }
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);

        setForm({
          ...form,
          dadosPessoais: {
            ...form.dadosPessoais, endereco: {
              ...form.dadosPessoais.endereco,
              cep: "",
              estado: "",
              cidade: "",
              rua: "",
              bairro: "",
              complemento: "",
            }
          }
        });
        Toast.fire({
          icon: "error",
          title: "CEP inválido",
        });
      });
  }

  function checkSenha(password) {
    if (!password) return;
    const pattern = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g;

    if (!pattern.test(password)) {
      Toast.fire({
        icon: "error",
        title: "A senha deverá conter no mínimo oito dígitos, ao menos um número, uma letra maiúscula e um caractere especial.",
      });
      setForm({
        ...form,
        dadosPessoais: { ...form.dadosPessoais, senha: "" },
      });
    }

  }

  function validaSenha(senha, confirmaSenha) {
    if (senha !== confirmaSenha) {
      Toast.fire({
        icon: "error",
        title: "Confirmação de senha inválida",
      });
      setForm({
        ...form,
        dadosPessoais: { ...form.dadosPessoais, confirmacaoSenha: "" }
      })
    }
  }

  function handleDataNascimento(data) {
    if (!data) return;

    if (validaData(data) === false) {
      setForm({ ...form, dadosPessoais: { ...form.dadosPessoais, dataNascimento: "" } });
      Toast.fire({ icon: "error", title: "Data inválida" });
      return;
    }

    let idade = validaData(data)

    if (!(idade > 0) || !(idade < 100)) {
      setForm({ ...form, dadosPessoais: { ...form.dadosPessoais, dataNascimento: "" } });
      Toast.fire({ icon: "error", title: "A idade precisa ser maior que 0 anos e menor que 100 anos" });
      return;
    }

  }

  function handleCPF(cpf) {
    if (!cpf) return;
    if (!validaCpf(cpf)) {
      setForm({
        ...form,
        dadosPessoais: { ...form.dadosPessoais, cpf: "" }
      })
      Toast.fire({
        icon: "error",
        title: "CPF inválido",
      });
    }
  }

  const header = (<>
    <img src={logo} alt="logo" style={{ maxWidth: "250px" }} />
  </>)

  const inicio = (<>
    <ChipDivider label="Início" />

    <FormControl>
      <FormLabel>Eu sou...</FormLabel>
      <RadioGroup row onChange={async (e) => {
        await setForm({ ...form, perfil: e.target.value });
        sectionRef.current.scrollIntoView({ behavior: 'smooth' });
      }} >
        <FormControlLabel value="Estudante" control={<Radio />} label="Estudante" />
        <FormControlLabel value="Agente Multiplicador" control={<Radio />} label="Agente Multiplicador" />
      </RadioGroup>
    </FormControl>

    {form?.perfil && (<>
      <Typography component="h1" variant="h5" sx={{ paddingY: 2 }} ref={sectionRef}>
        Bem-vindo(a)!
      </Typography>

      <Typography component="h1" variant="subtitle1" sx={{ paddingY: 1 }}>
        <p><b>Parabéns por dar esse importante passo em direção ao seu empoderamento!</b></p>
        <p>É com grande satisfação que nós, Recode e Secretaria de Inovação e Tecnologia de São Paulo, te recebemos aqui!</p>
        <p>Esse rápido cadastro nos ajudará a te conhecer melhor e o incluirá em nossa plataforma de ensino 100% online e 100% gratuita.</p>
        <p>Após o preenchimento e conclusão, fique atento à sua caixa de e-mail. Você receberá a confirmação de cadastro com o link da plataforma e todos os seus dados de acesso.</p>
        <p>Dentro da plataforma, temos o canal “Me ajuda” para qualquer dúvida ou dificuldade ao longo de sua jornada.</p>
        <p>Conte conosco.</p>
        <p>Time Recode</p>
      </Typography>
    </>)}
  </>)

  const dadosPessoais = (<>
    <Grid container spacing={2}>
      <ChipDivider label="Cadastro Recode" />

      <Grid item xs={12}>
        <Autocomplete disablePortal
          disableClearable
          noOptionsText="Item não encontrado na lista"
          options={telecentros}
          getOptionLabel={(option) => option?.nome || ''}
          onChange={(e, v) => setForm({ ...form, telecentro: v.id })}
          renderInput={(params) => <TextField required {...params} label="Selecione o nome telecentro que te apoia na execução das Trilhas Recode" />}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          type="email"
          inputProps={{ maxLength: 50 }}
          label="E-mail"
          autoComplete="xablaw"
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, email: e.target.value }
          })}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          required fullWidth
          type={showPassword ? 'text' : 'password'}
          inputProps={{ maxLength: 50 }}
          label="Senha"
          autoComplete="xablaw"
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, senha: e.target.value }
          })}
          value={form?.dadosPessoais.senha || ""}
          onBlur={() => checkSenha(form.dadosPessoais.senha)}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={togglePasswordVisibility}
                edge="end"
              >
                {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          required fullWidth
          type={showPassword ? 'text' : 'password'}
          inputProps={{ maxLength: 50 }}
          label="Confirmação de Senha"
          autoComplete="xablaw"
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, confirmacaoSenha: e.target.value }
          })}
          value={form?.dadosPessoais.confirmacaoSenha || ""}
          onBlur={() => validaSenha(form.dadosPessoais.senha, form.dadosPessoais.confirmacaoSenha)}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={togglePasswordVisibility}
                edge="end"
              >
                {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} >
        <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
          A senha deverá conter oito dígitos, ao menos um número, uma letra maiúscula e um caractere especial (+ - [ ] * ~ _ @ # :?) e não pode conter espaços.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <TextField
          autoComplete="xablaw" required fullWidth
          label="Nome completo" inputProps={{ maxLength: 200 }}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, nomeCompleto: e.target.value }
          })}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          autoComplete="xablaw" fullWidth
          required={form.dadosPessoais.usoNomeSocial}
          label="Nome social completo" inputProps={{ maxLength: 200 }}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, nomeSocialCompleto: e.target.value }
          })}
        />
      </Grid>

      <Grid item xs={12} >
        <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
          Nome social é a designação pela qual a pessoa travesti ou transexual se identifica e é socialmente reconhecida (DECRETO Nº 8.727, DE 28 DE ABRIL DE 2016).
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          label="Desejo utilizar meu nome social na plataforma e na emissão de certifcados"
          control={<Switch
            onChange={(e) => setForm({
              ...form,
              dadosPessoais: { ...form.dadosPessoais, usoNomeSocial: e.target.checked }
            })}
          />}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControl>
          <FormLabel>Nacionalidade</FormLabel>
          <RadioGroup row onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, nacionalidade: e.target.value }
          })} >
            <FormControlLabel value="Brasileiro(a)" control={<Radio required />} label="Brasileiro(a)" />
            <FormControlLabel value="Outro(a)" control={<Radio required />} label="Outra" />
          </RadioGroup>
        </FormControl>
      </Grid>

      {form.dadosPessoais?.nacionalidade === "Outro(a)" && (<>
        <Grid item xs={12} sm={6}>
          <TextField
            autoComplete="xablaw" required fullWidth
            label=" Insira sua nacionalidade" inputProps={{ maxLength: 200 }}
            onChange={(e) => setForm({
              ...form,
              dadosPessoais: { ...form.dadosPessoais, nacionalidadeOutro: e.target.value }
            })}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            autoComplete="xablaw" required fullWidth
            label="Documento de identifcação" inputProps={{ maxLength: 200 }}
            onChange={(e) => setForm({
              ...form,
              dadosPessoais: { ...form.dadosPessoais, documentoDeIdentifcacao: e.target.value }
            })}
          />
        </Grid>
      </>)}

      {form.dadosPessoais?.nacionalidade === "Brasileiro(a)" && (<>
        <Grid item xs={12}>
          <InputMask
            mask="999.999.999-99"
            inputProps={{ inputMode: 'numeric' }}
            autoComplete="xablaw"
            required fullWidth
            label="CPF"
            value={form?.dadosPessoais.cpf || ""}
            onBlur={(e) => {
              handleCPF(e.target.value);
            }}
            onChange={(e) => setForm({
              ...form,
              dadosPessoais: { ...form.dadosPessoais, cpf: e.target.value }
            })}>
            {(inputProps) => <TextField {...inputProps} />}
          </InputMask>
        </Grid>
      </>)}


      <Grid item xs={12} sm={6}>
        <TextField
          required fullWidth
          type="date" InputLabelProps={{ shrink: true }}

          autoComplete="xablaw"
          label="Data de Nascimento"
          value={form?.dadosPessoais.dataNascimento}
          onBlur={(e) => handleDataNascimento(e.target.value)}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, dataNascimento: e.target.value }
          })}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <InputMask
          mask="(99) 99999-9999"
          maskChar=""
          inputProps={{ inputMode: 'numeric' }}
          autoComplete="xablaw"
          required
          fullWidth
          label="Telefone"
          value={form?.dadosPessoais.telefone || ""}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, telefone: e.target.value }
          })}
          onBlur={() => form.dadosPessoais.telefone.length < 15 ? setForm({ ...form, dadosPessoais: { ...form.dadosPessoais, telefone: "" } }) : null}
        >

          {(inputProps) => <TextField {...inputProps} />}
        </InputMask>

        <FormControlLabel
          label="Este telefone é meu WhatsApp"
          control={<Switch
            onChange={(e) => setForm({
              ...form,
              dadosPessoais: { ...form.dadosPessoais, whatsapp: e.target.checked }
            })}
          />}
        />
      </Grid>
    </Grid>
  </>)

  const endereco = (<>
    <Grid container spacing={2}>
      <ChipDivider label="Endereço" />
      <Grid item xs={12}>
        <InputMask
          mask="99999-999"
          inputProps={{ inputMode: 'numeric' }}
          autoComplete="xablaw"
          required fullWidth
          label="CEP"
          value={form?.dadosPessoais.endereco.cep || ''}
          onBlur={checkCep}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, cep: e.target.value } }
          })}>
          {(inputProps) => <TextField {...inputProps} />}
        </InputMask>
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required>
          <InputLabel >Estado</InputLabel>
          <Select

            label="Estado"
            value={form?.dadosPessoais.endereco.estado || ''}
            disabled={!estados}
            onChange={(e) => setForm({
              ...form,
              dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, estado: e.target.value, cidade: "" } }
            })}
          >
            {estados && estados.sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR')).map((estado) => <MenuItem key={estado.id} value={estado.sigla}>{estado.nome}</MenuItem>)}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required>
          <InputLabel >Cidade</InputLabel>
          <Select
            label="Cidade"
            value={form?.dadosPessoais.endereco.cidade || ''}
            disabled={!form?.dadosPessoais.endereco.estado}
            onChange={(e) => setForm({
              ...form,
              dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, cidade: e.target.value } }
            })}
          >
            {cidades && cidades.sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR')).map((cidade) => <MenuItem key={cidade.id} value={cidade.nome}>{cidade.nome}</MenuItem>)}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          autoComplete="xablaw" required fullWidth
          value={form?.dadosPessoais.endereco.rua || ''}
          label="Endereço/Rua/Avenida" inputProps={{ maxLength: 200 }}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, rua: e.target.value } }
          })}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          autoComplete="xablaw" required fullWidth
          value={form?.dadosPessoais.endereco.bairro || ''}
          label="Bairro" inputProps={{ maxLength: 200 }}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, bairro: e.target.value } }
          })}
        />
      </Grid>

      {/* <Grid item xs={12} sm={6}>
        <TextField
          required
          autoComplete="xablaw" fullWidth
          label="Número" inputProps={{ maxLength: 200 }}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, numero: e.target.value } }
          })}
        />
      </Grid> */}

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required={!semNumero}
          autoComplete="xablaw"
          label={semNumero ? "Sem número" : "Número"}
          inputProps={{ maxLength: 200 }}
          value={form.dadosPessoais.endereco.numero}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, numero: e.target.value } }
          })}
          disabled={semNumero}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={() => {
                  setSemNumero(!semNumero);
                  setForm({ ...form, dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, numero: "" } } })
                }}
                edge="end"
              >
                {semNumero ? <AddCircleIcon /> : <RemoveCircleIcon />}
              </IconButton>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          autoComplete="xablaw" fullWidth
          value={form?.dadosPessoais.endereco.complemento || ''}
          label="Complemento" inputProps={{ maxLength: 200 }}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, complemento: e.target.value } }
          })}
        />
      </Grid>
    </Grid>
  </>)

  const dadosSociodemograficos = (<>
    <Grid container spacing={2}>
      <ChipDivider label="Sociodemográficos" />
      <Grid item xs={12}>
        <FormControl fullWidth required>
          <InputLabel>Como se identifca em relação ao seu gênero?</InputLabel>
          <Select
            label="Como se identifca em relação ao seu gênero?"
            value={form?.dadosSociodemograficos.genero || ''}
            onChange={(e) => setForm({
              ...form,
              dadosSociodemograficos: { ...form.dadosSociodemograficos, genero: e.target.value }
            })}
          >
            <MenuItem value="Homem">Homem</MenuItem>
            <MenuItem value="Homem trans">Homem trans</MenuItem>
            <MenuItem value="Mulher">Mulher</MenuItem>
            <MenuItem value="Mulher trans">Mulher trans</MenuItem>
            <MenuItem value="Prefiro não informar">Prefiro não informar</MenuItem>
            <MenuItem value="Outro">Outro</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {form.dadosSociodemograficos.genero === "Outro" && (
        <Grid item xs={12}>
          <TextField
            autoComplete="xablaw" required fullWidth
            label="Qual?" inputProps={{ maxLength: 200 }}
            onChange={(e) => setForm({
              ...form,
              dadosSociodemograficos: { ...form.dadosSociodemograficos, generoOutro: e.target.value }
            })}
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <FormControl fullWidth required>
          <InputLabel>Você se identifca como LGBTQIAPN+?</InputLabel>
          <Select
            label="Você se identifca como LGBTQIAPN+?"
            value={form?.dadosSociodemograficos.lgbt || ''}
            onChange={(e) => setForm({
              ...form,
              dadosSociodemograficos: { ...form.dadosSociodemograficos, lgbt: e.target.value }
            })}
          >
            <MenuItem value="Sim">Sim</MenuItem>
            <MenuItem value="Não">Não</MenuItem>
            <MenuItem value="Prefiro não informar">Prefiro não informar</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} >
        <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
          A sigla LGBTQIAPN+ representa pessoas que são Lésbicas, Gays, Bissexuais, Transexuais, Queer, Intersexo, Assexuais, Pansexuais e Não-binárias.
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required>
          <InputLabel>Você é uma pessoa com deficiência?</InputLabel>
          <Select
            label="Você é uma pessoa com deficiência?"
            value={form?.dadosSociodemograficos.deficiencia || ''}
            onChange={(e) => setForm({
              ...form,
              dadosSociodemograficos: { ...form.dadosSociodemograficos, deficiencia: e.target.value }
            })}
          >
            <MenuItem value="Não">Não</MenuItem>
            <MenuItem value="Sim, deficiência auditiva">Sim, deficiência auditiva</MenuItem>
            <MenuItem value="Sim, deficiência visual">Sim, deficiência visual</MenuItem>
            <MenuItem value="Sim, deficiência física">Sim, deficiência física</MenuItem>
            <MenuItem value="Sim, deficiência intelectual">Sim, deficiência intelectual</MenuItem>
            <MenuItem value="Sim, deficiência múltipla">Sim, deficiência múltipla</MenuItem>
            <MenuItem value="Prefiro não informar">Prefiro não informar</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required>
          <InputLabel>Você se considera refugiado?</InputLabel>
          <Select
            label="Você se considera refugiado?"
            value={form?.dadosSociodemograficos.refugiado || ''}
            onChange={(e) => setForm({
              ...form,
              dadosSociodemograficos: { ...form.dadosSociodemograficos, refugiado: e.target.value }
            })}
          >
            <MenuItem value="Sim">Sim</MenuItem>
            <MenuItem value="Não">Não</MenuItem>
            <MenuItem value="Prefiro não informar">Prefiro não informar</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} >
        <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
          Refugiado/a é a pessoa que está “fora de seu país de origem devido a fundados temores de perseguição relacionados a questões de raça, religião, nacionalidade, pertencimento a um determinado grupo social ou opinião política, como também devido à grave e generalizada violação de direitos humanos e confitos armados”, segundo a ACNUR, Agência da ONU para Refugiados.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FormControl fullWidth required>
          <InputLabel>Como se identifca em relação a sua raça/etnia?</InputLabel>
          <Select
            label="Como se identifca em relação a sua raça/etnia?"
            value={form?.dadosSociodemograficos.raca || ''}
            onChange={(e) => setForm({
              ...form,
              dadosSociodemograficos: { ...form.dadosSociodemograficos, raca: e.target.value }
            })}
          >
            <MenuItem value="Branca">Branca</MenuItem>
            <MenuItem value="Amarela">Amarela</MenuItem>
            <MenuItem value="Parda">Parda</MenuItem>
            <MenuItem value="Preta/Negra">Preta/Negra</MenuItem>
            <MenuItem value="Indígena">Indígena</MenuItem>
            <MenuItem value="Quilombola">Quilombola</MenuItem>
            <MenuItem value="Extrativista">Extrativista</MenuItem>
            <MenuItem value="Outro">Outro</MenuItem>
            {/* <MenuItem value="Prefiro não informar">Prefiro não informar</MenuItem> */}
          </Select>
        </FormControl>
      </Grid>

      {["Outro", "Extrativista", "Quilombola"].includes(form?.dadosSociodemograficos?.raca) && (
        <Grid item xs={12}>
          <TextField
            autoComplete="xablaw" required fullWidth
            label="Qual o nome de sua comunidade (Quilombola, extrativista ou comunidade tradicional)?" inputProps={{ maxLength: 200 }}
            onChange={(e) => setForm({
              ...form,
              dadosSociodemograficos: { ...form.dadosSociodemograficos, comunidadeResidencia: e.target.value }
            })}
          />
        </Grid>
      )}

      {form?.dadosSociodemograficos?.raca === "Indígena" && (<>
        <Grid item xs={12}>
          <Autocomplete disablePortal
            disableClearable
            noOptionsText="Item não encontrado na lista"
            options={povos.povosIndigenas}
            value={form?.dadosSociodemograficos.povo || ''}
            onChange={(e, v) =>
              setForm({
                ...form,
                dadosSociodemograficos: { ...form.dadosSociodemograficos, povo: v }
              })
            }
            renderInput={(params) => <TextField required {...params} label="Qual é o seu povo?" />}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Qual o seu documento de comprovação de etnia indígena?</InputLabel>
            <Select
              label="Qual o seu documento de comprovação de etnia indígena?"
              value={form?.dadosSociodemograficos.comprovacaoIndigena || ''}
              onChange={(e) => setForm({
                ...form,
                dadosSociodemograficos: { ...form.dadosSociodemograficos, comprovacaoIndigena: e.target.value }
              })}
            >
              <MenuItem value="Registro de Nascimento Indígena (Rani)">Registro de Nascimento Indígena (Rani)</MenuItem>
              <MenuItem value="Autodeclaração de pertencimento étnico indígena">Autodeclaração de pertencimento étnico indígena</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {form?.dadosSociodemograficos?.comprovacaoIndigena === "Registro de Nascimento Indígena (Rani)" && (
          <Grid item xs={12}>
            <TextField
              autoComplete="xablaw" required fullWidth
              label="Qual o nome de sua comunidade (Quilombola, extrativista ou comunidade tradicional)?" inputProps={{ maxLength: 200 }}
              onChange={(e) => setForm({
                ...form,
                dadosSociodemograficos: { ...form.dadosSociodemograficos, rani: e.target.value }
              })}
            />
          </Grid>
        )}
      </>)}

      <Grid item xs={12}>
        <FormControl fullWidth required>
          <InputLabel>Qual seu nível de escolaridade?</InputLabel>
          <Select
            label="Qual seu nível de escolaridade?"
            value={form?.escolaridade || ''}
            onChange={(e) => setForm({ ...form, escolaridade: e.target.value })}
          >
            <MenuItem value="Ensino Fundamental incompleto">Ensino Fundamental incompleto</MenuItem>
            <MenuItem value="Ensino Fundamental completo">Ensino Fundamental completo</MenuItem>
            <MenuItem value="Ensino Médio incompleto">Ensino Médio incompleto</MenuItem>
            <MenuItem value="Ensino Médio completo">Ensino Médio completo</MenuItem>
            <MenuItem value="Graduação incompleta">Graduação incompleta</MenuItem>
            <MenuItem value="Graduação completa">Graduação completa</MenuItem>
            <MenuItem value="Pós-graduação incompleta ou mais">Pós-graduação incompleta ou mais</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {/*
      <Grid item xs={12}>
        <FormControl fullWidth required>
          <InputLabel>Como é seu acesso à internet?</InputLabel>
          <Select
            label="Como é seu acesso à internet?"
            value={form?.acessoInternet || ''}
            onChange={(e) => setForm({ ...form, acessoInternet: e.target.value })}
          >
            <MenuItem value="Sim">Sim</MenuItem>
            <MenuItem value="Não">Não</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} >
        <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
          As aulas acontecem de modo remoto, ao vivo, via ferramentas para chamadas em grupo. Assim, você precisa ter acesso à internet com banda larga fixa ou móvel de ao menos 4Mb (quatro megabytes) de velocidade.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FormControl fullWidth required>
          <InputLabel>Você possui computador/notebook</InputLabel>
          <Select
            label="Você possui computador/notebook"
            value={form?.computador || ''}
            onChange={(e) => setForm({ ...form, computador: e.target.value })}
          >
            <MenuItem value="Sim">Sim</MenuItem>
            <MenuItem value="Não">Não</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} >
        <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
          É preciso que o computador/notebook esteja disponível para você no turno escolhido, pois as aulas acontecem de modo remoto, ao vivo. E o equipamento deve ter, no mínimo, a seguinte configuração: processador Core i5, 8gb de memória RAM, SSD 180gb ou superior.
        </Typography>
      </Grid> */}

      <Grid item xs={12}>
        <FormControl fullWidth required>
          <InputLabel>Como ficou sabendo</InputLabel>
          <Select
            label="Como ficou sabendo"
            value={form?.ficouSabendo || ''}
            onChange={(e) => setForm({ ...form, ficouSabendo: e.target.value })}
          >
            <MenuItem value="Telecentros/FabLab">Telecentros/FabLab</MenuItem>
            <MenuItem value="Instagram / Twitter / Facebook">Instagram / Twitter / Facebook</MenuItem>
            <MenuItem value="Indicação de colega ou familiar">Indicação de colega ou familiar</MenuItem>
            <MenuItem value="Site Recode">Site Recode</MenuItem>
            <MenuItem value="Via site de busca">Via site de busca</MenuItem>
            <MenuItem value="Email marketing">Email marketing</MenuItem>
            <MenuItem value="WhatsApp">WhatsApp</MenuItem>
            <MenuItem value="Comercial de TV">Comercial de TV</MenuItem>
            <MenuItem value="Youtube">Youtube</MenuItem>
            <MenuItem value="Via Instituição parceira">Via Instituição parceira</MenuItem>
            <MenuItem value="Quebrando o Tabu">Quebrando o Tabu</MenuItem>
            <MenuItem value="Outros">Outros</MenuItem>

          </Select>
        </FormControl>
      </Grid>
    </Grid>
  </>)

  const blocoTermos = (<>
    <Grid container spacing={2}>
      <ChipDivider label="Termos" />
    </Grid>
    {termos
      .sort((a, b) =>
        a.obrigatorio > b.obrigatorio
          ? 1
          : b.obrigatorio > a.obrigatorio
            ? -1
            : 0
      )
      .map((termo, index) => (
        <Grid item xs={12} key={index}>
          <FormControlLabel
            required={termo.obrigatorio}
            control={<Checkbox
              checked={form?.termos?.[termo?.nome] || false}
              onChange={(e) => {
                setForm({
                  ...form,
                  termos: { ...form.termos, [termo.nome]: e.target.checked, },
                })
              }}
            />}
            label={<span>
              {termo.descricao + " "}
              {termo.link && <Link rel="noopener noreferrer" href={termo.link} target="_blank"><OpenInNewIcon /></Link>}
            </span>}



          />
        </Grid>
      ))}
  </>)

  const redirect = () => window.location.replace("https://techsp.recode.org.br/login");

  const dialog = (<>
    <Dialog
      open={open}
      keepMounted
      // onClose={() => redirect()}
      onClose={redirect}
    >
      <DialogTitle>Sucesso!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Parabéns pelo cadastro.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={redirect}>Concluir</Button>
      </DialogActions>
    </Dialog>
  </>)

  function submit(form) {
    // setLoading(false)
    // alert("Check console log")
    // return console.log(form)
    const request = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    }

    fetch(`${process.env.REACT_APP_BACKEND}/api/SMIT/Cadastro`, request)
      .then((response) => response.json())
      .then((data) => {
        console.warn(data)
        if (data.success) {
          setOpen(true)
        } else {
          Toast.fire({
            icon: "error",
            title: data.message,
          });
        }
      })
      .finally(() => setLoading(false))
  }

  const handleForm = (e) => {
    e.preventDefault()
    setLoading(true)

    let body = { ...form, termos: termosParaEnviar(form.termos) }

    submit(body)
  }

  async function submitWidget() {
    setIsWidgetLoading(true)
    console.log(widgetForm)
    await fetch(`${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/DispararEmail`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nomeRementente: widgetForm.nome,
        emailRemetente: widgetForm.email,
        projeto: widgetForm.projeto,
        assunto: widgetForm.assunto,
        corpo: widgetForm.corpo
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          Toast.fire({ icon: "success", title: "Sua mensagem foi enviada com sucesso!" });
          setWidgetForm({ nome: "", email: "", assunto: "", projeto: "TechSp", corpo: "" })
        } else {
          Toast.fire({ icon: "warning", title: "Espere alguns instantes para enviar uma nova mensagem." });
        }
      })
      .catch((error) => {
        console.log("error", error);
        Toast.fire({ icon: "Erro", title: "Um erro ocorreu!" });
      })
      .finally(() => {
        setIsWidgetLoading(false)
        setWidgetIsOpen(false)
      });
  }

  const [isWidgetLoading, setIsWidgetLoading] = useState(false)
  const [widgetForm, setWidgetForm] = useState({
    nome: "",
    email: "",
    assunto: "",
    projeto: "PovosDaFloresta",
    corpo: ""
  });

  return (
    <ThemeProvider theme={lightTheme}>
      <Widget
        content={
          <form
            style={{ display: "flex", gap: "5px", flexDirection: "column" }}
            onSubmit={(e) => {
              e.preventDefault();
              submitWidget();
            }}
          >
            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Nome"
                value={widgetForm.nome}
                onChange={(e) => setWidgetForm({ ...widgetForm, nome: e.target.value })}
              />
            </InputArea>

            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Email"
                type="email"
                placeholder="estudante@email.com"
                value={widgetForm.email}
                onChange={(e) => setWidgetForm({ ...widgetForm, email: e.target.value })}
              />
            </InputArea>

            <InputArea>
              <Select
                disabled={isWidgetLoading}
                className={styles.select}
                required
                label="Assunto"
                onChange={(e) => setWidgetForm({ ...widgetForm, assunto: e.target.value })}
              >
                <option>Elogio</option>
                <option>Dúvida</option>
                <option>Cadastro</option>
                <option>Problema técnico</option>
                <option>Outro</option>
              </Select>
            </InputArea>

            <InputArea>
              <textarea
                disabled={isWidgetLoading}
                className={styles.textarea}
                required
                rows={5}
                placeholder="Sua mensagem"
                value={widgetForm.corpo}
                onChange={(e) => setWidgetForm({ ...widgetForm, corpo: e.target.value })}
              ></textarea>
            </InputArea>

            <InputArea>
              <ContainedBtn
                className={styles.submitBtn}
                disabled={isWidgetLoading} > {!isWidgetLoading ? "Enviar" : "Enviando..."} </ContainedBtn>
            </InputArea>
          </form>
        }
      />
      <CssBaseline />
      <HelmetThemeColor color={themeColor} />
      <Container maxWidth="md" sx={{ paddingY: 3 }}>
        <form
          onSubmit={handleForm}
          autoComplete="off"
        // noValidate
        >
          <Box sx={{
            ...box,
            alignItems: "center",
          }}>
            {header}
          </Box>

          <Box sx={box}>
            {inicio}
          </Box>

          {form.perfil && (
            <>
              <Box sx={box}>
                {dadosPessoais}
              </Box>

              <Box sx={box}>
                {endereco}
              </Box>

              <Box sx={box}>
                {dadosSociodemograficos}
              </Box>

              <Box sx={box}>
                {blocoTermos}
              </Box>

              <Box sx={box}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2, p: 1 }}
                  disabled={loading}
                >
                  {!loading ? "Cadastrar" : <CircularProgress color="secondary" size={22} />}
                </Button>
              </Box>
            </>
          )}

          <Box
            xs={12}
            sx={{
              paddingTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* <img src={regua} alt="régua de logos" style={{ maxWidth: "100%" }} /> */}
          </Box>

        </form>
        {dialog}
      </Container>
    </ThemeProvider>
  )
}
